var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"title"},[_vm._v("已关联的小程序")]),_vm._v(" "),_c('div',{staticClass:"content-container"},_vm._l((_vm.list),function(item,index){return _c('up-small-app-card',{key:index,staticClass:"card",attrs:{"item":item},on:{"refresh":_vm.refresh}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0da3c5ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/upManage/Manage.vue
// module id = null
// module chunks = 